import React, { useState, useEffect } from "react";
import {
  Link,
  useLoaderData,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import ModalProductDetails from "../../Components/Modal/ModalInventory/ModalProductDetails";
import toast from "react-hot-toast";
import LoaderProductCards from "../../Components/pageLoader/LoaderProductCards";

const EventProducts = () => {
  const { products, totalPages } = useLoaderData();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDropdown, setIsDropdown] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [loading, setLoading] = useState(true); // Loader state, initially true

  // Get the current page from the URL, defaulting to 1
  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setLoading(false); // Turn off loader after data is loaded
    }, 1000);

    return () => clearTimeout(timer); // Cleanup on component unmount
  }, []);


  const currentPage = parseInt(searchParams.get("page")) || 1;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setSearchParams({ page: nextPage }); // Update the search parameter, URL updates automatically
      setTimeout(() => setLoading(false), 1000); // Simulate loading time

    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setSearchParams({ page: prevPage }); // Update the search parameter, URL updates automatically
      setTimeout(() => setLoading(false), 1000); // Simulate loading time

    }
  };


  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const openModalProductDetails = (productId) => {
    setSelectedProductId(productId); // Set the selected product ID
    setIsDropdown(true);

  };

  const closeModalProductDetails = () => {
    setIsDropdown(false);
    setSelectedProductId(null); // Clear the selected product ID
  };

  const addToCart = (product) => {
    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    const productIndex = existingCart.findIndex(
      (item) => item._id === product._id
    );

    let updatedCart;
    if (productIndex > -1) {
      // If product already exists in cart, increment the quantity
      updatedCart = existingCart.map((item, index) =>
        index === productIndex ? { ...item, quantity: item.quantity + 1 } : item
      );
    } else {
      // Otherwise, add the product with a quantity of 1
      updatedCart = [...existingCart, { ...product, quantity: 1 }];
    }

    localStorage.setItem("cart", JSON.stringify(updatedCart)); // Save updated cart in localStorage
    // setCart(updatedCart); // Update cart state
    toast.success(`${product.title} has been added to the cart! View Cart`, {
      position: "bottom-center",
    });
  };

  return (
    <div className="bg-rose-100 min-h-screen">
       {loading && (
        <LoaderProductCards></LoaderProductCards>
      )}

      {!loading && (
        <>
        <div className="max-w-screen-2xl mx-auto p-4 h-full">
        <div className="h-full">
          <div className="grid grid-cols-5 gap-10">
            {products.map((product) => (
              <div className="w-64 border flex flex-col justify-between border-rose-100 shadow-md">
                <button
                  key={product._id}
                  onClick={() => openModalProductDetails(product._id)}
                >
                  <img
                    className="w-64 h-64 object-cover rounded"
                    src={product.singleImage}
                    alt={product.title}
                  />
                  <h1 className="mt-4 font-raleway font-semibold text-center text-lg text-rose-900 pb-5">
                    {product.title}
                  </h1>
                </button>
                <button
                  onClick={() => addToCart(product)}
                  className="text-center w-full py-2 font-raleway text-white bg-rose-800 duration-300 ease-in-out hover:bg-rose-900"
                >
                  Add to Wishlist
                </button>
              </div>
            ))}
          </div>
          <ModalProductDetails
            isVisible={isDropdown}
            onClose={closeModalProductDetails}
            productId={selectedProductId} // Pass the selected product ID to the modal
          />
          <div class="flex flex-col items-center my-10">
            <span class="text-md text-rose-900 font-raleway dark:text-gray-400">
              Page {currentPage} of {totalPages}
            </span>
            <div class="inline-flex mt-2 xs:mt-0">
              <button
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 rounded-s hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <svg
                  class="w-3.5 h-3.5 me-2 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 5H1m0 0 4 4M1 5l4-4"
                  />
                </svg>
                Prev
              </button>
              <button
                onClick={handleNextPage}
                class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 border-0 border-s border-gray-700 rounded-e hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                Next
                <svg
                  class="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
        </>
      )}
      
    </div>
  );
};

export default EventProducts;
